module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Coral Blue.b3acd6bc.png";